export default __webpack_public_path__ + "static/assets/med_pill_round_out_L2_solid_x_01_f_mask.b2655208.png";